"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.substituteEnvVars = void 0;
const _ = require("lodash");
if (!env) {
    throw new Error("Need an env object");
}
/**
 * Substitute environment variables into a string. Allows the remote styleForm definition to use the app settings.
 */
const substituteEnvVars = (urlStr) => {
    _.each(env, (v, k) => {
        urlStr = urlStr.replace(`{${k}}`, v);
    });
    if (urlStr.match(/[{}]/)) {
        throw new Error(`Unrecognised environment variable in URL (${urlStr})`);
    }
    return urlStr;
};
exports.substituteEnvVars = substituteEnvVars;
//# sourceMappingURL=substituteEnvVars.js.map